//
//
//
//
//
//
//

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        tag: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    }
};
